import React from 'react';
import Loadable from 'react-loadable';
import Main from './components/Main';

function Loading(error) {
  if(error.error !== null){
    console.log(error)
  }
  return <div>Loading...</div>;
}
const WorkSpace = Loadable({
  loader: () => import('./components/WorkSpace'),
  loading: Loading,
});
const Results = Loadable({
  loader: () => import('./components/Results'),
  loading: Loading,
});
const Guide = Loadable({
  loader: () => import('./components/popup/createInitialDashboard/CreateInitialDashboard'),
  loading: Loading,
});
const Alert = Loadable({
  loader: () => import('./components/alert/index'),
  loading: Loading,
});
const AuthorSearch = Loadable({
  loader: () => import('./components/authorSearch/index'),
  loading: Loading,
});
const PopKeyword = Loadable({
  loader: () => import('./components/popkeyword/index'),
  loading: Loading,
});

const FBAuthorSearch = Loadable({
  loader: () => import('./components/channelSearch/facebook/index'),
  loading: Loading,
});
const YoutuberSearch = Loadable({
  loader: () => import('./components/channelSearch/youtube/index'),
  loading: Loading,
});


const routes = [
	{ path: '/', exact: true, name: 'Home', component: Main },
	{ path: '/results', name: 'results', component: Results },
  { path: '/workspace', name: 'workspace', component: WorkSpace },
  { path: '/guide', name: 'guide', component: Guide },
  { path: '/alert', name: 'alert', component: Alert },
  { path: '/authorsearch',name:'authorsearch',component: AuthorSearch},
  { path: '/popkeyword',name:'popkeyword',component: PopKeyword},
  { path: '/facebookSearch',name:'popkeyword',component: FBAuthorSearch},
  { path: '/youtuberSearch',name:'popkeyword',component: YoutuberSearch},
// 	{ path: '/popupdemo', name: 'popupdemo', component: Popupdemo },
  // { path: '/work-space', name: 'workSpace', component: WorkSpace }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js